import React, { forwardRef } from "react";

const CustomDatepicker = forwardRef(({ value, onClick }, ref) => {
  return (
    <input
      ref={ref}
      value={value}
      onClick={onClick} // Allows opening the datepicker
      readOnly // Prevents on-screen keyboard
      className="custom-date-picker"
    />
  );
});

export default CustomDatepicker;
